import page from './page'
import appList from './app-list'

export default {
    install: function (Vue) {
        Vue.component('my-page', page)
        Vue.component('app-list', appList)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js